import { render } from "./price.vue?vue&type=template&id=0013f5ab&scoped=true"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"

import "./price.vue?vue&type=style&index=0&id=0013f5ab&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0013f5ab"]])

export default __exports__